import {
  logs,
  SeverityNumber,
  type AnyValue,
  type AnyValueMap,
} from '@opentelemetry/api-logs';
import { INSTRUMENTATION } from 'constant/instrumentation';
import { getWindowLocationPathname } from 'utils/functions/window';

const logger = logs.getLogger(INSTRUMENTATION.SERVICE_NAME);

/**
 * @param body - Use body for the main message
 * @param attrs - attributes for structured data
 */
export function emitInfoLog({
  body,
  attrs,
  severityNumber = SeverityNumber.INFO,
}: {
  body: AnyValue;
  attrs?: AnyValueMap;
  severityNumber?: SeverityNumber;
}) {
  logger.emit({
    body: body,
    severityNumber,
    severityText: 'INFO',
    attributes: {
      ...attrs,
      screenName: getWindowLocationPathname(),
    },
  });
}

export function emitWarnLog({
  body,
  attrs,
  severityNumber = SeverityNumber.WARN,
}: {
  body: AnyValue;
  attrs?: AnyValueMap;
  severityNumber?: SeverityNumber;
}) {
  logger.emit({
    body,
    severityNumber,
    severityText: 'WARN',
    attributes: {
      ...attrs,
      screenName: getWindowLocationPathname(),
    },
  });
}

export function emitErrorLog({
  body,
  attrs,
  severityNumber = SeverityNumber.ERROR,
}: {
  body: AnyValue;
  attrs?: AnyValueMap;
  severityNumber?: SeverityNumber;
}) {
  logger.emit({
    body,
    severityNumber,
    severityText: 'ERROR',
    attributes: {
      ...attrs,
      screenName: getWindowLocationPathname(),
    },
  });
}

export function emitFatalLog({
  body,
  attrs,
  severityNumber = SeverityNumber.FATAL,
}: {
  body: AnyValue;
  attrs?: AnyValueMap;
  severityNumber?: SeverityNumber;
}) {
  logger.emit({
    body,
    severityNumber,
    severityText: 'FATAL',
    attributes: {
      ...attrs,
      screenName: getWindowLocationPathname(),
    },
  });
}
